module.exports = __webpack_public_path__ + "static/media/29BDOS26.691e52c1.jpg";